<div class="progress-cont">
    <div
        class="progress"
        style="width: 100%"
        [style.width]="progress + '%'"
    ></div>
</div>
